import React, { useRef } from "react";
import {
  aboutbg,
  buttonbg,
  herobg,
  heroimage,
  roadmap,
  star,
  team1,
  team2,
  team3,
  team4,
  visionimage,
} from "../Assets";

const teamData = [
  {
    number: 1,
    image: team1,
    imageBg: "#57DBFF",
    name: "Mr. Bubbles",
    description: "Handles the big picture and keeps everything moving forward",
    tags: ["Founder", "Project Lead"],
  },
  {
    number: 2,
    image: team2,
    imageBg: "#FF9D57",
    name: "Shawn",
    description: "Builds the smart contracts and makes the tech work",
    tags: ["Project Developer"],
  },
  {
    number: 3,
    image: team3,
    imageBg: "#E251FF",
    name: "Ella",
    description: "Creates all the visual designs and NFT artwork",
    tags: ["Lead Artist"],
  },
  {
    number: 4,
    image: team4,
    imageBg: "#5765FF",
    name: "Enzo",
    description: "Engages with holders and keeps the community active",
    tags: ["Community Manager"],
  },
];




const Home = () => {

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400; // Adjust as needed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full h-full">
      {/* Hero Section */}
      <section
        className="w-full relative min-h-screen flex flex-col items-center justify-center text-center px-4 overflow-hidden bg-cover bg-center"
        style={{ backgroundImage: `url(${herobg})` }}
        id="home"
      >
        {/* Text Content */}
        <div className="max-w-8xl relative z-10 space-y-6 -mt-20 md:pt-0">
          <h1 className="text-4xl sm:text-4xl md:text-7xl lg:text-8xl xl:text-9xl text-white font-bold leading-tight sm:leading-snug relative z-20">
            Break the Bubble <br /> Own the Moment
          </h1>

          {/* Centered Subtext for Small Screens */}
          <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-center sm:justify-between gap-4 mt-6">
            <p className="text-white text-sm sm:text-base max-w-md text-center lg:text-left leading-relaxed">
              PopYourBubbles is where ideas{" "}
              <span className="text-[#313131]">explode</span>, limits vanish,
              and your NFT isn’t just art, it’s a statement.
            </p>

            <p className="text-white text-sm sm:text-base max-w-md text-center sm:text-right leading-relaxed">
              One <span className="text-[#313131]">bubble</span> at a time,
              we’re reshaping reality.
            </p>
          </div>
        </div>

        {/* Centered Image at Bottom */}
        <img
          src={heroimage}
          alt="Hero"
          className="w-full sm:w-[600px] absolute bottom-16 md:-bottom-12 left-1/2 transform -translate-x-1/2 z-10"
          style={{ pointerEvents: "none" }}
        />

{/* Bottom Button and Text */}
<div className="w-full flex flex-row  justify-between items-start md:items-end absolute bottom-0 md:bottom-6 left-0 px-8 z-10">
  
  {/* Explore Button (Left) */}
  <a href="#vision" className="relative inline-block group">
    {/* Image Background Behind Button */}
    <img
      src={buttonbg}
      alt="Button Background"
      className="absolute -bottom-8 -left-8  max-w-[200px] sm:w-[200px] md:w-[300px] lg:w-[400px] -z-10"
    />

    {/* Foreground Button */}
    <button className="flex items-center gap-2 px-6 py-2 bg-[#EEEEEE] text-[#000000] font-semibold rounded-xl transition-transform duration-300 relative z-10">
      Explore
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </a>

  {/* Text on the Right (Bottom-Aligned) */}
  <div className="text-right">
    <p className="text-[#FFC300] text-3xl font-bold">
      Popyour <br />
      <span className="text-[#171717]">Bubbles</span>
    </p>
  </div>
</div>
      </section>

      {/* Our Vision Section */}
      <section className="w-full bg-white py-20 px-4 sm:px-12" id="vision">
        {/* Section Title */}
        <div className="max-w-7xl mx-auto space-y-12 relative">
          {/* Background Title */}
          <p className="absolute top-0 left-0 text-[4rem] sm:text-[12rem] md:text-[12rem] font-bold text-[#171717] opacity-5 leading-none z-0 pointer-events-none">
            VISION
          </p>

          {/* Foreground Title */}
          <h2 className="text-4xl sm:text-6xl md:text-8xl font-bold text-left text-[#171717] relative z-10">
            Our <span className="text-[#159BFB]">Vision</span>
          </h2>

          {/* Content Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center relative z-10">
            {/* Left Column */}
            <div className="space-y-8">
              <p className="text-base sm:text-lg text-[#333333] leading-relaxed">
                At PopYourBubbles, we believe NFTs should be more than just
                digital collectibles. They should be dynamic, engaging, and full
                of surprises. By combining AI-powered creativity with blockchain
                technology, we’re redefining what NFTs can be. Our vision is
                simple: to create a vibrant, ever-evolving ecosystem where art,
                innovation, and community come together, one bubble at a time.
                Join us as we push boundaries and make digital ownership fun,
                interactive, and truly unique.
              </p>

              {/* Star + Text Row */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                <img src={star} alt="Star Icon" className="w-20 sm:w-24" />
                <span className="text-[#000000] font-semibold text-base sm:text-lg text-center sm:text-left">
                  One bubble <br /> at a time.
                </span>
              </div>
            </div>

            {/* Right Column (Image) */}
            <div className="flex justify-center">
              <img
                src={visionimage}
                alt="Vision"
                className="w-full max-w-sm sm:max-w-md rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section
        className="w-full py-16 px-4 sm:px-8 flex justify-center"
        id="about"
      >
        <div
          className="w-full max-w-7xl rounded-3xl bg-cover bg-center shadow-xl overflow-hidden"
          style={{ backgroundImage: `url(${aboutbg})` }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 sm:p-10 md:p-12 rounded-3xl">
            {/* Left Column - Heading */}
            <div className="flex items-center justify-center md:justify-start text-center md:text-left">
              <h2 className="text-4xl sm:text-6xl md:text-8xl xl:text-9xl font-bold text-white leading-tight">
                About <br /> Bubbles
              </h2>
            </div>

            {/* Right Column - Paragraph */}
            <div className="flex items-center">
              <p className="text-white text-sm sm:text-base md:text-lg leading-relaxed space-y-4">
                PopYourBubbles is an AI-powered NFT collection bursting onto the{" "}
                <span className="text-black font-semibold">
                  Monad blockchain
                </span>
                , where art, innovation, and interactivity collide. Each dynamic
                "bubble" is a unique digital masterpiece,{" "}
                <span className="text-black font-semibold">
                  algorithmically crafted to evolve
                </span>
                , surprise, and delight its owner—making that owner (bubbler)
                unique in all of the blockchain.
                <br />
                <br />
                Owners don’t just collect; they unlock exclusive
                experiences—from generative art transformations to
                community-driven creations. This includes perks, rewards, and
                airdrops tied to each “bubble” they own.
                <br />
                <br />
                Whether you're a crypto-art enthusiast or a curious explorer,{" "}
                <span className="text-black font-semibold">
                  PopYourBubbles invites you to pop the ordinary and embrace the
                  extraordinary.
                </span>{" "}
                PopYourBubbles’ MO remains to redefine creativity one bubble at
                a time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section
        className="w-full relative py-24 bg-white overflow-hidden px-4 sm:px-8"
        id="team"
      >
        {/* Background Title */}
        <p className="absolute top-0 left-0 text-[4rem] sm:text-[12rem] md:text-[12rem] font-bold text-[#171717] opacity-5 leading-none z-0 pointer-events-none">
          TEAM
        </p>

        {/* Foreground Title */}
        <h2 className="text-[80px] sm:text-[140px] md:text-[180px] font-bold text-[#EDEDED] absolute top-8 left-4 sm:left-12 -z-10 leading-none">
          Team
        </h2>

        {/* Intro Row */}
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-16 z-10 relative">
          <h3 className="text-4xl sm:text-6xl md:text-7xl font-bold text-[#171717] text-center md:text-left">
            Team Bubbles
          </h3>
          <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left justify-center md:justify-start">
            <img src={star} alt="Star Icon" className="w-16 sm:w-20" />
            <p className="text-[#333] text-base sm:text-xl md:text-2xl font-semibold max-w-md">
              PopYourBubbles’ MO remains to redefine creativity
            </p>
          </div>
        </div>

        {/* Cards Wrapper */}
        <div className="w-full bg-[#D9D9D933] rounded-3xl py-8 px-4 sm:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8 max-w-7xl mx-auto z-10 relative">
          {teamData.map((member, index) => (
            <div
              key={index}
              className="bg-[#57AEFF] rounded-3xl p-6 flex flex-col items-start shadow-md"
            >
              {/* Number */}
              <p className="text-white text-lg sm:text-xl font-bold mb-4">
                0{member.number}
              </p>

              {/* Image Container */}
              <div
                className="w-full aspect-square rounded-xl border-4 border-white mb-4 flex items-center justify-center"
                style={{ backgroundColor: member.imageBg }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="object-contain max-h-full max-w-full"
                />
              </div>

              {/* Name */}
              <h4 className="text-white text-lg sm:text-xl font-semibold mb-2">
                {member.name}
              </h4>

              {/* Description */}
              <p className="text-white text-sm sm:text-base mb-4">
                {member.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {member.tags.map((tag, i) => (
                  <span
                    key={i}
                    className="text-sm bg-[#FFC300] text-black px-3 py-1 rounded-lg"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Roadmap Section */}
      <section className="w-full bg-white py-20" id="roadmap">
      <div className="w-full mx-auto space-y-6">
        {/* Title */}
        <h2 className=" max-w-7xl px-4 mx-auto text-4xl sm:text-6xl font-bold text-[#171717] text-left">
          Roadmap
        </h2>

        {/* Slide hint */}
        <p className="max-w-7xl px-4 mx-auto text-[#999] text-sm sm:text-base">
          Slide right <span className="inline-block">→</span>
        </p>

        {/* Scroll Buttons */}
        <div className="max-w-7xl px-4 mx-auto  flex justify-end gap-4">
          <button
            onClick={() => scroll("left")}
            className="px-3 py-2 bg-[#EEE] rounded hover:bg-[#CCC] transition"
          >
            ←
          </button>
          <button
            onClick={() => scroll("right")}
            className="px-3 py-2 bg-[#EEE] rounded hover:bg-[#CCC] transition"
          >
            →
          </button>
        </div>

        {/* Scrollable Container */}
        <div
          ref={scrollRef}
          className="overflow-x-auto whitespace-nowrap scrollbar-hide mt-4"
        >
          <img
            src={roadmap}
            alt="Roadmap"
            className="inline-block w-[1200px] sm:w-[1600px] max-w-none"
          />
        </div>
      </div>
    </section>
    </div>
  );
};

export default Home;
